<template>

  <div @click="deleteItem()">
    <m-icon :icon="iconName" class="cursor-pointer delete-1-icon"/>
    <slot></slot>
  </div>

</template>

<script>
import mIcon from '../../Icons/Icon.vue'

export default {
  name: "Delete1",
  components: {mIcon},
  props: {
    itemId: {
      default: null
    },
    itemType: {
      options: ['product',], // 'course', 'post', 'page', 'lesson',
      default: 'product'
    },
    iconName: {
      default: 'files'
    },
  },
  methods: {
    deleteItem() {
      if (confirm(this.$t('tools.delete.confirm_alarm_message'))) {

        if (this.itemType === 'product') {
          this.$store.dispatch("Product/deleteProduct", {id: this.itemId});
        }

      }
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>